<template>
  <v-footer color="blue darken-2">
    <v-layout row wrap align-center>
      <v-col
        class="text-center"
        cols="12"
      >
        <a href="https://www.ksk.co.jp/business/ai-suishin.html" target="_brank" class="white--text">株式会社 ＫＳＫ</a>
      </v-col>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
